import markerSrcMain from'../images/marker-default.png';
import markerSrcBegraafplaats from'../images/marker-begraafplaats.png';
import markerSrcCentrum from'../images/marker-centrum.png';
import markerSrcEten from'../images/marker-eten.png';
import markerSrcKerk from'../images/marker-kerk.png';
import markerSrcMedisch from'../images/marker-medisch.png';
import markerSrcRecreatie from'../images/marker-recreatie.png';
import markerSrcSport from'../images/marker-sport.png';
import markerSrcStation from'../images/marker-station.png';
import markerSrcStudie from'../images/marker-studie.png';

const markers = [markerSrcMain, markerSrcBegraafplaats, markerSrcCentrum, markerSrcEten, markerSrcStudie, markerSrcKerk, markerSrcMedisch, markerSrcRecreatie, markerSrcSport, markerSrcStation];

export default markers;